import {
  FETCH_STR_CASE_REPORT_BY_CASE_ID,
  FETCH_STR_CASE_REPORT_BY_CASE_ID_SUCCESS,
  FETCH_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  UPDATE_STR_CASE_REPORT_BY_CASE_ID,
  UPDATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS,
  UPDATE_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  CREATE_STR_CASE_REPORT_BY_CASE_ID,
  CREATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS,
  CREATE_STR_CASE_REPORT_BY_CASE_ID_FAIL,
  CLOSE_SUCCESS_MODAL,
  CLOSE_ERROR_MODAL,
  FETCH_REPORT_METADATA,
  FETCH_REPORT_METADATA_SUCCESS,
  FETCH_REPORT_METADATA_FAIL,
  FETCH_TRANSACTION_LIST,
  FETCH_TRANSACTION_LIST_SUCCESS,
  FETCH_TRANSACTION_LIST_FAIL,
  FETCH_PARTIES_LIST,
  FETCH_PARTIES_LIST_SUCCESS,
  FETCH_PARTIES_LIST_FAIL,
  FETCH_TRANSACTION_LIST_DOWNLOAD,
  FETCH_TRANSACTION_LIST_DOWNLOAD_SUCCESS,
  FETCH_TRANSACTION_LIST_DOWNLOAD_FAIL,
  UPDATE_REPORTING_INSTITUTION,
  UPDATE_REPORTING_INSTITUTION_SUCCESS,
  UPDATE_REPORTING_INSTITUTION_FAIL,
  CLEAR_REPORTING_INSTITUTION_ERROR,
  UPDATE_TRANSACTION_LIST,
  UPDATE_TRANSACTION_LIST_SUCCESS,
  UPDATE_TRANSACTION_LIST_FAIL,
  CLEAR_TRANSACTION_LIST_ERROR,
  UPDATE_PARTIES_LIST,
  UPDATE_PARTIES_LIST_SUCCESS,
  UPDATE_PARTIES_LIST_FAIL,
  CLEAR_PARTIES_LIST_ERROR,
  UPDATE_INVESTIGATION_DETAILS,
  UPDATE_INVESTIGATION_DETAILS_SUCCESS,
  UPDATE_INVESTIGATION_DETAILS_FAIL,
  CLEAR_INVESTIGATION_DETAILS_ERROR
} from '../../actions/cm/caseReport';

export const initialState = {
  isLoading: false,
  hasError: false,
  success: false,
  updateSuccess: false,
  caseReport: null,
  errorMessage: null,
  reportMetadata: {
    isLoading: false,
    hasLoaded: false,
    hasError: false,
    data: null,
    errorMessage: null
  },
  transactionList: null,
  partiesList: null,
  downloadTransactionList: {
    isLoading: false,
    data: null,
    hasError: false,
    errorMessage: null
  },
  updateReportingInstitution: {
    isLoading: false,
    isSuccess: false,
    hasError: false,
    errorMessage: null
  },
  updateTransactionList: {
    isLoading: false,
    isSuccess: false,
    hasError: false,
    errorMessage: null
  },
  updatePartiesList: {
    isLoading: false,
    isSuccess: false,
    hasError: false,
    errorMessage: null
  },
  updateInvestigationDetails: {
    isLoading: false,
    isSuccess: false,
    hasError: false,
    errorMessage: null
  }
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_STR_CASE_REPORT_BY_CASE_ID:
      return {
        ...state,
        isLoading: true,
        success: false,
        updateSuccess: false,
        hasError: false
      };
    case FETCH_STR_CASE_REPORT_BY_CASE_ID_SUCCESS:
      return {
        ...state,
        caseReport: payload,
        isLoading: false
      };
    case FETCH_STR_CASE_REPORT_BY_CASE_ID_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        caseReport: null,
        errorMessage: payload.message
      };
    case UPDATE_STR_CASE_REPORT_BY_CASE_ID:
      return {
        ...state,
        isLoading: true,
        updateSuccess: false,
        hasError: false
      };
    case UPDATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        updateSuccess: true
      };
    case UPDATE_STR_CASE_REPORT_BY_CASE_ID_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        updateSuccess: false,
        errorMessage: payload.message
      };
    case CREATE_STR_CASE_REPORT_BY_CASE_ID_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        success: false,
        errorMessage: payload.message
      };

    case CREATE_STR_CASE_REPORT_BY_CASE_ID:
      return {
        ...state,
        isLoading: true,
        success: false,
        hasError: false
      };
    case CREATE_STR_CASE_REPORT_BY_CASE_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        success: true,
        caseReport: payload
      };
    case CLOSE_SUCCESS_MODAL:
      return {
        ...state,
        success: false,
        updateSuccess: false
      };
    case CLOSE_ERROR_MODAL:
      return {
        ...state,
        hasError: false
      };
    case FETCH_REPORT_METADATA:
      return {
        ...state,
        reportMetadata: {
          ...state.reportMetadata,
          isLoading: true,
          hasLoaded: false,
          hasError: false,
          data: null
        }
      };
    case FETCH_REPORT_METADATA_SUCCESS:
      return {
        ...state,
        reportMetadata: {
          ...state.reportMetadata,
          hasLoaded: true,
          isLoading: false,
          data: payload
        }
      };
    case FETCH_REPORT_METADATA_FAIL:
      return {
        ...state,
        reportMetadata: {
          ...state.reportMetadata,
          data: null,
          isLoading: false,
          hasError: true,
          errorMessage: payload.message
        }
      };

    case FETCH_TRANSACTION_LIST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        transactionList: {
          ...state.transactionList,
          data: []
        }
      };
    case FETCH_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        transactionList: payload
      };
    case FETCH_TRANSACTION_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        transactionList: null,
        errorMessage: payload.message
      };
    case FETCH_PARTIES_LIST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        partiesList: {
          ...state.partiesList,
          data: []
        }
      };
    case FETCH_PARTIES_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        partiesList: payload
      };
    case FETCH_PARTIES_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        partiesList: null,
        errorMessage: payload.message
      };
    case FETCH_TRANSACTION_LIST_DOWNLOAD:
      return {
        ...state,
        downloadTransactionList: {
          ...state.downloadTransactionList,
          isLoading: true,
          hasError: false
        }
      };
    case FETCH_TRANSACTION_LIST_DOWNLOAD_SUCCESS:
      return {
        ...state,
        downloadTransactionList: {
          ...state.downloadTransactionList,
          isLoading: false,
          data: payload
        }
      };
    case FETCH_TRANSACTION_LIST_DOWNLOAD_FAIL:
      return {
        ...state,
        downloadTransactionList: {
          ...state.downloadTransactionList,
          isLoading: false,
          data: null,
          hasError: true,
          errorMessage: payload.message
        }
      };
    case UPDATE_REPORTING_INSTITUTION:
      return {
        ...state,
        updateReportingInstitution: {
          ...state.updateReportingInstitution,
          isLoading: true,
          isSuccess: false,
          hasError: false,
          errorMessage: null
        }
      };
    case UPDATE_REPORTING_INSTITUTION_SUCCESS:
      return {
        ...state,
        updateReportingInstitution: {
          ...state.updateReportingInstitution,
          isLoading: false,
          isSuccess: true,
          data: payload
        }
      };
    case UPDATE_REPORTING_INSTITUTION_FAIL:
      return {
        ...state,
        updateReportingInstitution: {
          ...state.updateReportingInstitution,
          isLoading: false,
          hasError: true,
          errorMessage: payload.message
        }
      };
    case CLEAR_REPORTING_INSTITUTION_ERROR:
      return {
        ...state,
        updateReportingInstitution: {
          ...state.updateReportingInstitution,
          isSuccess: false,
          data: null,
          hasError: false,
          errorMessage: null
        }
      };

    case UPDATE_TRANSACTION_LIST:
      return {
        ...state,
        updateTransactionList: {
          ...state.updateTransactionList,
          isLoading: true,
          isSuccess: false,
          hasError: false,
          errorMessage: null
        }
      };
    case UPDATE_TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        updateTransactionList: {
          ...state.updateTransactionList,
          isLoading: false,
          isSuccess: true
        }
      };
    case UPDATE_TRANSACTION_LIST_FAIL:
      return {
        ...state,
        updateTransactionList: {
          ...state.updateTransactionList,
          isLoading: false,
          hasError: true,
          errorMessage: payload.message
        }
      };
    case CLEAR_TRANSACTION_LIST_ERROR:
      return {
        ...state,
        updateTransactionList: {
          ...state.updateTransactionList,
          isSuccess: false,
          hasError: false,
          errorMessage: null
        }
      };

    case UPDATE_PARTIES_LIST:
      return {
        ...state,
        updatePartiesList: {
          ...state.updatePartiesList,
          isLoading: true,
          isSuccess: false,
          hasError: false,
          errorMessage: null
        }
      };
    case UPDATE_PARTIES_LIST_SUCCESS:
      return {
        ...state,
        updatePartiesList: {
          ...state.updatePartiesList,
          isLoading: false,
          isSuccess: true
        }
      };
    case UPDATE_PARTIES_LIST_FAIL:
      return {
        ...state,
        updatePartiesList: {
          ...state.updatePartiesList,
          isLoading: false,
          hasError: true,
          errorMessage: payload.message
        }
      };
    case CLEAR_PARTIES_LIST_ERROR:
      return {
        ...state,
        updatePartiesList: {
          ...state.updatePartiesList,
          isSuccess: false,
          hasError: false,
          errorMessage: null
        }
      };
    case UPDATE_INVESTIGATION_DETAILS:
      return {
        ...state,
        updateInvestigationDetails: {
          ...state.updateInvestigationDetails,
          isLoading: true,
          isSuccess: false,
          hasError: false,
          errorMessage: null
        }
      };
    case UPDATE_INVESTIGATION_DETAILS_SUCCESS:
      return {
        ...state,
        updateInvestigationDetails: {
          ...state.updateInvestigationDetails,
          isLoading: false,
          isSuccess: true
        }
      };
    case UPDATE_INVESTIGATION_DETAILS_FAIL:
      return {
        ...state,
        updateInvestigationDetails: {
          ...state.updateInvestigationDetails,
          isLoading: false,
          hasError: true,
          errorMessage: payload.message
        }
      };
    case CLEAR_INVESTIGATION_DETAILS_ERROR:
      return {
        ...state,
        updateInvestigationDetails: {
          ...state.updateInvestigationDetails,
          isSuccess: false,
          hasError: false,
          errorMessage: null
        }
      };

    default:
      return state;
  }
}
